import ApiService from "@/services/api.service";

export default {
    namespaced: true,
    state: {
        listClients: {},
        listCities: [],
        loading: false,
        globalLoading: false,
        error: {},
    },
    getters: {
        getListClients: (state) => state.listClients,
        getListCities: (state) => state.listCities,
        getLoading: (state) => state.loading,
        error: (state) => state.error,
    },
    mutations: {
        SET_CLIENTS_LIST(state, listClients) {
            state.listClients = listClients;
        },
        SET_CITIES_LIST(state, listCities) {
            state.listCities = listCities;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        },
        SET_GLOBAL_LOADING(state, val) {
            state.globalLoading = val;
        },
        SET_ERROR(state, val) {
            state.error = val;
        },
    },
    actions: {
        FETCH_LIST_CLIENTS({ commit }, query) {
            commit("SET_LOADING", true);

            return new Promise((resolve) => {
                ApiService.get(`Cliente?${query}`)
                    .then((res) => {
                        commit("SET_CLIENTS_LIST", res.data);
                        commit("SET_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => {
                            commit("SET_ERROR", "");
                            commit("SET_LOADING", false);
                        }, 5000);
                    });
            });
        },

        FETCH_LIST_CITIES({ commit }) {
            return new Promise((resolve) => {
                ApiService.get(`Citta/cittaList`)
                    .then((res) => {
                        commit("SET_CITIES_LIST", res.data);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                    });
            });
        },

        CREATE_CLIENT({ commit }, params) {
            commit("SET_GLOBAL_LOADING", true);

            return new Promise((resolve, reject) => {
                ApiService.upload(`Cliente`, params)
                    .then((res) => {
                        commit("SET_GLOBAL_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        commit("SET_GLOBAL_LOADING", false);
                        reject(response);
                    });
            });
        },
        GET_CLIENT({ commit }, id) {
            return new Promise((resolve) => {
                ApiService.download(`Cliente`, id)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                    });
            });
        },
        UPDATE_CLIENT({ commit }, { id, params }) {
            commit("SET_GLOBAL_LOADING", true);
            return new Promise((resolve, reject) => {
                ApiService.uploadModifica(`Cliente/${id}`, params)
                    .then((res) => {
                        commit("SET_GLOBAL_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        commit("SET_GLOBAL_LOADING", false);
                        reject(response);
                    });
            });
        },
    },
};
